import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { TERMS_OF_USE_LINK, PRIVACY_POLICY_LINK } from '../../shared/links';
import styles from './AgreementTextV3.css';

const cx = classnames.bind(styles);

function AgreementTextV3({ className, legalLinks = { privacyPolicy: PRIVACY_POLICY_LINK, termsOfUse: TERMS_OF_USE_LINK } }) {
    return (
        <p className={cx('agreementText', className)}>
            {'For self-reflection only — this is not a psychological assessment. By continuing you agree to the '}
            <CustomLink
                to={legalLinks.termsOfUse}
                target='_blank'
            >
                Terms&nbsp;of&nbsp;Use
            </CustomLink>
            {' and '}
            <CustomLink
                to={legalLinks.privacyPolicy}
                target='_blank'
            >
                Privacy&nbsp;Policy
            </CustomLink>
            .
        </p>
    );
}

AgreementTextV3.propTypes = {
    className: PropTypes.string,
    legalLinks: PropTypes.object
};

AgreementTextV3.defaultProps = {
    className: ''
};

export {
    AgreementTextV3
};
